<template>
  <div class="tabs-underline__menu">
    <div ref="tabMenuRef" class="tabs-underline__menu-wrapper">
      <TabsUnderline
        v-for="(tabItem, index) in tabItems"
        :key="'tabItem-' + index"
        :tabText="tabItem.title"
        :tabIcon="tabItem.icon"
        :amount="isLoading ? '-' : tabItem.items.length"
        @toggleActiveTab="toggleActiveContent"
      />
    </div>
  </div>
  <div
    v-if="totalResultsCount > 0"
    v-show="!isLoading"
    ref="tabContentRef"
    class="tabs-underline__content-wrapper"
  >
    <ListStandard
      v-for="(tabItem, index) in tabItems"
      :id="tabItem.title"
      :key="`tab-${index}`"
      class="tabs-underline__content"
      :icon="tabItem.icon"
      :items="tabItem.items"
      :searchString="searchString"
      @select="onSelect"
    >
    </ListStandard>
  </div>
</template>

<script setup lang="ts">
import { toRefs, ref, onMounted, computed, watch } from 'vue'
import ListStandard from './ListStandard.vue'
import TabsUnderline from '../atoms/TabsUnderline.vue'

const props = defineProps({
  tabItems: {
    type: Object,
    default: () => {}
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  searchString: {
    type: String,
    default: ''
  }
})
const { tabItems, searchString } = toRefs(props)
// Emits (defineEmits)
interface EMITS {
  (e: 'select', item: object): void
}
const emits = defineEmits<EMITS>()
// Reactive variables etc
const tabMenuRef = ref<HTMLElement | null>(null)
const tabContentRef = ref<HTMLElement | null>(null)
// computed
const totalResultsCount = computed(() => {
  let totalCount = 0
  tabItems.value.forEach((tab) => {
    totalCount += tab.items.length
  })
  return totalCount
})
// methods
function onSelect(item: object) {
  emits('select', item)
}
function toggleActiveContent(clickedTab: string) {
  const currentActive = document.querySelectorAll(
    '.tabs-underline__content[active], .tab-underline[active]'
  )
  const newActive = document.querySelector(`#${clickedTab}`)
  if (currentActive) currentActive.forEach((el) => el.toggleAttribute('active'))
  if (newActive) newActive.toggleAttribute('active')
}

watch(searchString, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    tabMenuRef.value?.firstElementChild?.toggleAttribute('active')
    tabContentRef.value?.firstElementChild?.toggleAttribute('active')
  }
})
watch(tabContentRef, (newVal) => {
  if (newVal) tabContentRef.value?.firstElementChild?.toggleAttribute('active')
})

// lifecycle hooks
onMounted(() => {
  tabMenuRef.value?.firstElementChild?.toggleAttribute('active')
  tabContentRef.value?.firstElementChild?.toggleAttribute('active')
})
</script>
<style lang="scss">
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/mixins.scss';

.tabs-underline__menu {
  border-bottom: variables.$button-text-icon-border;
  height: variables.$dropdown-height-medium;

  &-wrapper {
    column-gap: variables.$gap-xlarge;
    display: flex;
    overflow: auto;
    padding: 0 variables.$padding-xlarge;
    &::-webkit-scrollbar {
      width: 0;
    }
  }
}
.tabs-underline__content {
  display: none;
  &[active] {
    display: block;
    overflow: auto;
  }
  &-wrapper {
    overflow: auto;
    @include mixins.scrollbar-vertical;
  }
}
</style>
